import { render, staticRenderFns } from "./EmbedEditor.vue?vue&type=template&id=18aa5f5e&scoped=true&"
import script from "./EmbedEditor.vue?vue&type=script&lang=js&"
export * from "./EmbedEditor.vue?vue&type=script&lang=js&"
import style0 from "./EmbedEditor.vue?vue&type=style&index=0&id=18aa5f5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18aa5f5e",
  null
  
)

export default component.exports